document.addEventListener('DOMContentLoaded', function() {
  var heroIdx = 0;
  var heroTimer = null;
  var slides = document.querySelectorAll('.hero-slide');
  var dots = document.querySelectorAll('.hero-dot');
  
  if (slides.length === 0) return;
  
  function goHeroSlide(i) {
    slides[heroIdx].classList.remove('active');
    if (dots[heroIdx]) dots[heroIdx].classList.remove('active');
    heroIdx = i % slides.length;
    slides[heroIdx].classList.add('active');
    if (dots[heroIdx]) dots[heroIdx].classList.add('active');
    clearInterval(heroTimer);
    heroTimer = setInterval(function() { goHeroSlide((heroIdx + 1) % slides.length); }, 3500);
  }
  
  // Expose globally for dot buttons
  window.goHeroSlide = goHeroSlide;
  
  // Start auto-advance
  heroTimer = setInterval(function() { goHeroSlide((heroIdx + 1) % slides.length); }, 3500);
});
